import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Select, { components } from "react-select";
import {
  createRecoCohort,
  updateRecoCohort,
  getDropdownValuesForCohortRecommendation,
  getFilterValues,
  getRadiologistForDropdown,
  updateReportCohort,
  createCohortReport,
  getReferrersForDropdownOptions,
  getFilterComputedData,
  getComputedStatus,
  getDropdownValuesForCohortReport,
} from "../../../actions/radminUploads";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { capitalize, debounce } from "lodash";
import { CalendarIcon } from "../../../components/Dialog/Icon";
import { TextField, InputLabel, makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Row, Spinner } from "react-bootstrap";
import Box from "../../../components/_styles/Box";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { ReactComponent as RemoveRecoIconHover } from "../../../assets/delete-hover.svg";
import { ReactComponent as InfoTooltipIcon } from "../../../assets/info-tooltip-icon.svg";
import { Tooltip, withStyles } from "@material-ui/core";

import DatePicker from "react-datepicker";
import moment from "moment";
import {
  DateContainer,
  DatePickerButton,
} from "../../../components/Dialog/EditFormCenter";
import { Card, PageTitle } from "../../../styles";
import RemoveConfirmation from "./RemoveConfirmation";

const Remove = styled.div`
  cursor: pointer;
`;
const RemoveContainer = styled.div``;

const IconContainer = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 30px;
  height: 20px;

  &:hover svg:not(.light) {
    display: none;
  }

  &:hover svg.light {
    display: block;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  svg.light {
    display: none;
  }
`;

const useStyles = makeStyles({
  label: {
    padding: "5px 0px",
    fontSize: "12px",
    fontWeight: "bold",
  },
  saveButton: {
    color: "#FFFFFF",
    backgroundColor: "#00AEEF",
    textTransform: "none",
    border: "2px solid transparent",
    width: "280px",
    "&:hover": {
      backgroundColor: "transparent",
      border: "2px solid #00AEEF",
      color: "#00AEEF",
    },
  },
  additionalSubDimensionsButton: {
    color: "#00AEEF",
    textTransform: "none",
    width: "250px",
    background: "transparent",
    border: "2px solid #00AEEF",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  additionalDimensionsButton: {
    color: "#00AEEF",
    textTransform: "none",
    width: "200px",
    background: "transparent",
    border: "2px solid #00AEEF",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  removeAllSubDimensionsButton: {
    color: "#CF3131",
    textTransform: "none",
    width: "200px",
    background: "transparent",
    border: "2px solid #CF3131",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  inputLabel: {
    marginTop: "35px",
    fontSize: "16px",
    textAlign: "left",
    color: "#3F4857",
    fontWeight: 600,
    textTransform: "uppercase",
  },
  textField: {
    width: "100%",
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13.5px 14px",
    },
  },
  title: {
    width: "100%",
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13.5px 14px",
    },
  },
  datePicker: {
    width: "100%",
    "& .react-datepicker": {
      fontSize: "1rem !important",
      top: "58px",
    },
  },
  valuePicker: {
    width: "25%",
  },
});

const Section = styled.div`
  display: flex;
  gap: 20px;
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  margin-top: 40px;
  gap: 20px;
`;

const CheckBoxLabel = styled.label`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom:0px;
`;

const CheckboxTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SwitchContainer = styled.div`
  padding: 4px;
  display: flex;
  background: #e6e9f1;
  border-radius: 8px;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: #0c2945;
  width: fit-content;
`;

const RemoveIconContainer = styled.div`
  display: flex;
  width: 15%;
  justify-content: space-between;
  margin-top: 30px;
`;

const StyledTooltip = (props) => {
  const { className, ...other } = props;

  return (
    <Tooltip
      {...other}
      PopperProps={{
        className: className,
        style: {
          backgroundColor: "#AEE3F8",
          marginBottom: "20px",
          borderRadius: "4px",
          zIndex: 3,
        },
      }}
    />
  );
};

const StyledTooltipWrapper = withStyles(() => ({
  tooltip: {
    backgroundColor: "transparent",
    color: "black!important",
    fontSize: "14px!important",
    fontWeight: 400 + "!important",
    width: "220px",
    padding: "10px",
    textAlign: "center",
    margin: "0px", 
    position: "relative",
  },
}))(StyledTooltip);

const SwitchButton = styled.button`
  padding: 7px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => (props.active ? "#0C2945" : "#E6E9F1")};
  color: ${(props) => (props.active ? "#F9FAFC" : "#0C2945")};
  font-weight: ${(props) => (props.active ? 700 : 600)};
  border: 0;
  outline: 0;
  border-radius: 6px;
`;

const operatorsArrayDropdownOnly = [
  "Contains",
  "Does not contain",
  "Is equal to",
  "Is not equal to",
];

const operatorsArrayBooleanOnly = ["Is equal to"];

const operatorsArrayText = [
  "Contains",
  "Does not contain",
  "Is equal to",
  "Is not equal to",
];

const operatorsArrayDate = [
  "Is equal to",
  "Is not equal to",
  "Is a timestamp after",
  "Is a timestamp before",
  "Is a timestamp greater than",
  "Is a timestamp less than",
];

const operatorsArrayDropdownSpecial = [
  "Contains",
  "Does not contain",
  "Is equal to",
  "Is not equal to",
  "Is greater than" ,
  "Is less than" 
]

const messageOnlyOperator = ["Is equal to", "Is not equal to"];
const constants = ["Dimensions", "Operators", "Values"];

const booleanValues = ["true", "false"];

const needsToBeBooleanValues = [
  "message_sent",
  "follow_up_recommended"
];
const needsToBeDateInputValues = [
 "initial_exam_date"
];
const needsToBeSpecialGuidelineDropdownValues = [
  "special_guideline_type",
  "special_guideline_score"
];
const needsToBeDropdownValues = [
  "modality",

];
const needsToBeFixedDropdownValues = ["age_group"];

const SelectContainer = styled.div`
  width: 250px;
  //   margin-top: 35px;
  display: flex;
  flex-direction: column;
  div.select__value-container {
    height: 38px;
    cursor: pointer;
  }
`;

const SelectDropdownTitle = styled.div`
  margin-bottom: 0.5rem;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const Container = styled.div`
  width: 95%;
  margin: 0 auto;
`;

const RadioOption = (props) => {
  return (
    <>
      <components.Option {...props}>
        <span style={{ marginRight: 5, paddingTop: 5 }}>
          <input
            type="radio"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginTop: 5 }}
          />{" "}
        </span>
        <label>{props.label}</label>
      </components.Option>
    </>
  );
};

const IndicatorsContainer = (props) => {
  return (
    <div style={{ backgroundColor: "#FFF" }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
          style={{ margin: "0 5px", verticalAlign: "middle" }}
        />{" "}
        <label style={{ margin: "0" }}>{props.label}</label>
      </components.Option>
    </div>
  );
};

const CreateReportCohort = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [firstFilterId, setFirstFilterId] = useState("");
  const [computedReportData, setComputedReportData] = useState();
  const recoConfigData = useSelector((state) => state.radAdmin.recoConfig.data);
  const isLoading = useSelector(
    (state) => state.radAdmin.cohortReports.isLoading
  );
  const isEditClicked =
    props.location.state?.data && props.location.state?.data !== "reports";
  const locationsOptionsList = useSelector(
    (state) => state.radAdmin.locationsOptionsList.data
  )?.results;
  const locations = locationsOptionsList;

  const locationOptions = locations?.length
    ? [].concat(
        locations
          .map((item) => ({
            value: item.location_address,
            label: item.location_address.replace(/\^/g, ","),
            category: "location",
          }))
          .filter((item) => item.value)
      )
    : [];

  const radiologists = useSelector(
    (state) => state.radAdmin.followUpList?.dropdownRadiologists.data
  );

  const hasReportSearchEventsEnabled =  useSelector((state) => state.auth.user.provider.report_search_event);


  const optionsList = useSelector(state => state.radAdmin.optionsList.data)?.results;
  const guidelineType = optionsList?.find(itm=>itm.key==="guideline_type")?.options;
  const guidelineScore = optionsList?.find(itm=>itm.key==="guideline_score")?.options;
  const guidelineTypeScore = optionsList?.find(itm=>itm.key==="guideline_type_score")?.options;

  const specialGuidelineType = optionsList?.find(itm=>itm.key==="special_guideline_type")?.options;
  const specialGuidelineScore = optionsList?.find(itm=>itm.key==="special_guideline_score")?.options;

  const guidelineTypeOptions = guidelineType?.length
  ? [].concat(guidelineType
      .map((item) => ({ value: item, label: item, category: "guideline_type" }))
      .filter((item) => item.value))
  : [];


  const guidelineScoreOptions = guidelineScore?.length
  ? [].concat(guidelineScore
      .map((item) => ({ value: item, label: item, category: "guideline_score" }))
      .filter((item) => item.value))
  : [];


  const guidelineTypeScoreOptions = guidelineTypeScore?.length
  ? [].concat(guidelineTypeScore
      .map((item) => ({ value: item, label: item, category: "guideline_type_score" }))
      .filter((item) => item.value))
  : [];

  const specialGuidelineTypeOptions = specialGuidelineType?.length
  ? [].concat(specialGuidelineType
      .map((item) => ({ value: item, label: item, category: "special_guideline_type" }))
      .filter((item) => item.value))
  : [];

  const specialGuidelineScoreOptions = specialGuidelineScore?.length
  ? [].concat(specialGuidelineScore
      .map((item) => ({ value: item, label: item, category: "special_guideline_score" }))
      .filter((item) => item.value))
  : [];



  const fixedValues = useSelector(
    (state) => state.radAdmin.cohortsRecommendations.fixedValues.data
  );
  const getFixedValues = (attribute) => {
    let data = fixedValues.find((val) => val.attribute === attribute);
    if (!data) return [];
    return data.values;
  };
  const radiologistOptions = radiologists?.length
    ? radiologists
        .map((item) => ({
          value: item?.id,
          label: capitalize(
            item?.first_name?.replace(/_/g, " ") +
              " " +
              item?.last_name?.replace(/_/g, " ")
          ),
          category: "radiologist",
        }))
        .filter((item) => item.value)
    : [];
  const [cohortName, setCohortName] = useState("");

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const [selectedOperator, setSelectedOperator] = useState(
    props.location.state?.data?.raw_filters?.condition === "or"
      ? { value: "or", label: "OR", category: "Operator" }
      : { value: "and", label: "AND", category: "Operator" }
  );
  const [mainRows, setMainRows] = useState([
    {
      subGroupCondition: "and",
      subGroups: [{ attribute: "", operator: "", value: "" }],
    },
  ]);

  const [filterOption, setFilterOptions] = useState([]);
  const [computedResults, setComputedResults] = useState([]);
  const [statusList, setStatusList] = useState()

  const [ageOptions, setAgeOptions] = useState([]);
  const [cohortFilters, setCohortFilters] = useState(
    props.location.state?.data?.raw_filters
  );

  function getDateDiff(date) {
    let today = new Date();

    let otherDate = new Date(date);
    today.setHours(0, 0, 0, 0);
    otherDate.setHours(0, 0, 0, 0);

    let differenceInMs = otherDate - today;

    const differenceInDays = Math.abs(
      Math.round(differenceInMs / (1000 * 60 * 60 * 24))
    );

    return differenceInDays;
  }

  useEffect(() => {
    if (props.location.state?.data !== "reports") {
      if (props.location.state?.data) {
        setCohortName(props.location.state?.data?.title);
        setIsChecked(props.location.state?.data?.trigger_cio_event);
        let filtersArray = cohortFilters?.filters;
  
        let arr = filtersArray.map((item) => {
          if (item.filters && item.condition) {
            return {
              subGroupCondition: item.condition,
              subGroups: item.filters.map((itm) => {
                if (
                  needsToBeDropdownValues.includes(itm.attribute) &&
                  isDropdownRequired(itm.attribute)
                ) {
                  dispatch(
                    getDropdownValuesForCohortReport(itm.attribute)
                  );
                }
                
                let operatorValue;
                if (itm.attribute === "special_guideline_score" && itm.operator === "__gte") {
                  operatorValue = { label: "Is greater than", value: "Is greater than" };
                } else if (itm.attribute === "special_guideline_score" && itm.operator === "__lte") {
                  operatorValue = { label: "Is less than", value: "Is less than" };
                } else if (itm.operator === "__gt") {
                  operatorValue = { label: "Is a timestamp after", value: "Is a timestamp after" };
                } else if (itm.operator === "__icontains" && itm.exclude === 0) {
                  operatorValue = { label: "Contains", value: "Contains" };
                } else if (itm.operator === "__icontains" && itm.exclude === 1) {
                  operatorValue = { label: "Does not contain", value: "Does not contain" };
                } else if (itm.operator === "__lt") {
                  operatorValue = { label: "Is a timestamp before", value: "Is a timestamp before" };
                } else if (itm.operator === "__gte") {
                  operatorValue = { label: "Is a timestamp greater than", value: "Is a timestamp greater than" };
                } else if (itm.operator === "__lte") {
                  operatorValue = { label: "Is a timestamp less than", value: "Is a timestamp less than" };
                } else if (itm.operator === "" && itm.exclude === 0) {
                  operatorValue = { label: "Is equal to", value: "Is equal to" };
                } else {
                  operatorValue = { label: "Is not equal to", value: "Is not equal to" };
                }
                
                let valueValue;
                
                if (itm.attribute === "special_guideline_score") {
                  if (typeof itm.value === 'object' && itm.value !== null && 'value' in itm.value) {
                    valueValue = itm.value.value;
                  } else {
                    valueValue = itm.value;
                  }
                } else if (itm.operator === "__gte" || itm.operator === "__lte") {
                  valueValue = getDateDiff(itm.value);
                } else if (itm.operator === "__gt" || itm.operator === "__lt") {
                  valueValue = new Date(itm.value);
                } else if (isDropdownRequired(itm.attribute)) {
                  valueValue = { label: itm.value, value: itm.value };
                } else if (itm.attribute === "guideline_type" || itm.attribute === 'guideline_type_score' || itm.attribute === "special_guideline_type") {
                  valueValue = { label: itm.value, value: itm.value };
                } else if (itm.attribute === "location_address") {
                  valueValue = { label: itm.value.replace(/\^/g, ","), value: itm.value };
                } else if (itm.attribute === "radiologist") {
                  valueValue = { label: itm.valueLabel, value: itm.value };
                } else if (itm.attribute === 'referring_physician') {
                  valueValue = { label: itm.valueLabel, value: itm.value };
                } else if (itm.attribute === "guideline_score") {
                  valueValue = { label: itm.value, value: itm.value };
                } else {
                  valueValue = itm.value == 0 ? String(itm.value) : itm.value;
                }
                
                return {
                  operator: operatorValue,
                  value: valueValue,  
                  exclude: itm.exclude,
                  attribute: {
                    label: itm.label,
                    value: itm.attribute,
                  },
                };
              }),
            };
          } else {
            let { attribute, label } = item;
  
            if (
              needsToBeDropdownValues.includes(attribute) &&
              isDropdownRequired(attribute)
            ) {
              dispatch(getDropdownValuesForCohortReport(attribute));
            }
            
            let operatorValue;
            if (attribute === "special_guideline_score" && item.operator === "__gte") {
              operatorValue = { label: "Is greater than", value: "Is greater than" };
            } else if (attribute === "special_guideline_score" && item.operator === "__lte") {
              operatorValue = { label: "Is less than", value: "Is less than" };
            } else if (item.operator === "__gt") {
              operatorValue = { label: "Is a timestamp after", value: "Is a timestamp after" };
            } else if (item.operator === "__icontains" && item.exclude === 0) {
              operatorValue = { label: "Contains", value: "Contains" };
            } else if (item.operator === "__icontains" && item.exclude === 1) {
              operatorValue = { label: "Does not contain", value: "Does not contain" };
            } else if (item.operator === "__lt") {
              operatorValue = { label: "Is a timestamp before", value: "Is a timestamp before" };
            } else if (item.operator === "__gte") {
              operatorValue = { label: "Is a timestamp greater than", value: "Is a timestamp greater than" };
            } else if (item.operator === "__lte") {
              operatorValue = { label: "Is a timestamp less than", value: "Is a timestamp less than" };
            } else if (item.operator === "__in" && item.exclude === 0) {
              operatorValue = { label: "Is equal to", value: "Is equal to" };
            } else if (item.operator === "__in" && item.exclude === 1) {
              operatorValue = { label: "Is not equal to", value: "Is not equal to" };
            } else if (item.operator === "" && item.exclude === 0) {
              operatorValue = { label: "Is equal to", value: "Is equal to" };
            } else {
              operatorValue = { label: "Is not equal to", value: "Is not equal to" };
            }
            
            let valueValue;
            
            if (attribute === "special_guideline_score") {
              if (typeof item.value === 'object' && item.value !== null && 'value' in item.value) {
                valueValue = item.value.value;
              } else {
                valueValue = item.value;
              }
            } else if (item.operator === "__gte" || item.operator === "__lte") {
              valueValue = getDateDiff(item.value);
            } else if (item.operator === "__gt" || item.operator === "__lt") {
              valueValue = new Date(item.value);
            } else if (isDropdownRequired(attribute)) {
              valueValue = { label: item.value, value: item.value };
            } else if (item.attribute === "guideline_type" || item.attribute === 'guideline_type_score' || item.attribute === "special_guideline_type") {
              valueValue = { label: item.value, value: item.value };
            } else if (attribute === "location_address") {
              valueValue = { label: item.value.replace(/\^/g, ","), value: item.value };
            } else if (attribute === "radiologist") {
              valueValue = { label: item.valueLabel, value: item.value };
            } else if (attribute === "computed_status") {
              valueValue = { label: item.valueLabel, value: item.value };
            } else if (attribute === 'referring_physician') {
              valueValue = { label: item.valueLabel, value: item.value };
            } else if (attribute === "guideline_score") {
              valueValue = { label: item.value, value: item.value };
            } else {
              valueValue = item.value;
            }
            
            return {
              subGroupCondition: "and",
              subGroups: [
                {
                  operator: operatorValue,
                  value: valueValue, 
                  exclude: item.exclude,
                  attribute: {
                    label: label,
                    value: attribute,
                  },
                },
              ],
            };
          }
        });
        setMainRows(arr);
      }
    }
  }, [dispatch, cohortFilters]);

  const findSpecialGuidelineType = (mainRow) => {
    return mainRow.subGroups.find(
      (sg) => 
        sg.attribute?.value === "special_guideline_type" &&
        (sg.operator?.value === "Contains" || sg.operator?.value === "Is equal to")
    );
  };

  const hasSpecialGuidelineScore = (mainRow) => {
    return mainRow.subGroups.some(
      (sg) => sg.attribute?.value === "special_guideline_score"
    );
  };

  const generateOptions = (interval) => {
    const maxAge = 100;
    const newOptions = [];
    let start = 1;

    const numGroups = Math.floor(maxAge / interval);
    let end = 0;

    for (let i = 0; i < numGroups; i++) {
      end = start + interval - 1;

      newOptions.push({
        value: `${start}-${end}`,
        label: `${start}-${end}`,
        category: "age",
      });

      start = end + 1;
    }

    if (
      interval === 5 ||
      interval === 10 ||
      interval === 20 ||
      interval === 25 ||
      interval === 50
    ) {
      newOptions.push({
        value: `101-150`,
        label: `101+`,
        category: "age",
      });
    } else if (interval === 15 || interval === 30) {
      newOptions.push({
        value: `91-150`,
        label: `91+`,
        category: "age",
      });
    } else if (interval === 35) {
      newOptions.push({
        value: `71-150`,
        label: `71+`,
        category: "age",
      });
    } else if (interval === 40) {
      newOptions.push({
        value: `81-150`,
        label: `81+`,
        category: "age",
      });
    } else if (interval === 45) {
      newOptions.push({
        value: `91-150`,
        label: `91+`,
        category: "age",
      });
    }

    setAgeOptions(newOptions);
  };

  useEffect(() => {
    generateOptions(recoConfigData?.patientAgeInterval ?? 5);
  }, [recoConfigData]);

  useEffect(() => {
    dispatch(getRadiologistForDropdown());

    dispatch(getFilterValues("report-cohort/attributes")).then((res) => {
      if (res) {
        setFilterOptions(res);
      }
      
    });

    dispatch(getFilterComputedData()).then((res) => {
     if(res) {
      const results = res?.results || [];
      setComputedResults(results);
  
      const selectedId = props.location?.state?.data?.computed_status_criteria?.id;
      const selectedItem = results.find((itm) => itm.id === selectedId);
  
      if (selectedItem) {
        setComputedReportData({
          ...selectedItem,
          label: capitalize(selectedItem.name?.replace(/_/g, " ")),
          value: selectedItem.id,
        });
      }
     }
    })
    dispatch(getComputedStatus()).then((res) => {
      if(res) {
      setStatusList(res?.map((itm) => ({
        label: itm.label,
        value: itm.key
      })))
      }
     })
  }, []);

  const addMainRow = () => {
    setMainRows((prevRows) => [
      ...prevRows,
      {
        subGroupCondition: "and",
        subGroups: [{ attribute: "", operator: "", value: "" }],
      },
    ]);
  };

  const addSubGroup = (mainRowIndex) => {
    setMainRows((prevRows) =>
      prevRows.map((row, index) =>
        index === mainRowIndex
          ? {
              ...row,
              subGroups: [
                ...row.subGroups,
                { attribute: "", operator: "", value: "" },
              ],
            }
          : row
      )
    );
  };

  const removeMainRow = (index) => {
    if (mainRows.length > 1) {
      setMainRows((prevRows) => prevRows.filter((_, i) => i !== index));
    }
  };

  const removeSubGroup = (mainRowIndex, subGroupIndex) => {
    setMainRows((prevRows) =>
      prevRows.map((row, index) => {
        if (index !== mainRowIndex) return row;
        
        return {
          ...row,
          subGroups: row.subGroups.filter((_, i) => i !== subGroupIndex),
        };
      })
    );
  };

  const updateSubGroupField = (mainRowIndex, subGroupIndex, field, value) => {
    setMainRows(prevRows =>
      prevRows.map((row, index) => {
        if (index !== mainRowIndex) return row;
  
        const currentSubGroup = row.subGroups[subGroupIndex];
        
        if (field === "attribute" && value?.value === "special_guideline_type") {
          return {
            ...row,
            subGroups: row.subGroups.map((sub, i) => {
              if (i === subGroupIndex) {
                return { 
                  [field]: value, 
                  operator: "", 
                  value: "" 
                };
              }
        
              return sub;
            }),
          };
        }
        
        if ((field === "operator" || field === "value") && 
            currentSubGroup?.attribute?.value === "special_guideline_type") {
          
          const newSubGroups = row.subGroups.map((sub, i) => {
            if (i === subGroupIndex) {
              return field === "operator"
                ? { ...sub, operator: value, value: "" }
                : { ...sub, [field]: value };
            }

            return sub;
          });
          
          return {
            ...row,
            subGroups: newSubGroups,
          };
        }
  
        if (field === "subGroupCondition") {
          
          return {
            ...row,
            subGroupCondition: value,
            subGroups: row.subGroups,
          };
        }
  
        if (field === "value" && Array.isArray(value)) {
          const baseSubGroup = row.subGroups[subGroupIndex];
          const newSubGroups = value.map(v => ({
            ...baseSubGroup,
            value: v,
          }));
          return {
            ...row,
            subGroups: [
              ...row.subGroups.slice(0, subGroupIndex),
              ...newSubGroups,
              ...row.subGroups.slice(subGroupIndex + 1),
            ],
          };
        }
  
        return {
          ...row,
          subGroups: row.subGroups.map((sub, i) =>
            i === subGroupIndex
              ? field === "attribute"
                ? { [field]: value, operator: "", value: "" }
                : field === "operator"
                ? { ...sub, [field]: value, value: "" }
                : field === "value"
                ? { ...sub, [field]: value }
                : sub
              : sub
          ),
        };
      })
    );
  };

  const toggleSubGroupCondition = (mainRowIndex) => {
    setMainRows((prevRows) =>
      prevRows.map((row, index) => {
        if (index !== mainRowIndex) return row;
        
        const newCondition = row.subGroupCondition === "and" ? "or" : "and";
       
        return {
          ...row,
          subGroupCondition: newCondition,
          subGroups: row.subGroups,
        };
      })
    );
  };


  const DatePickerInput = React.forwardRef((props, ref) => {
    const { onClick, date, time } = props;
    const formatDate = (date, time) => {
      return `${moment(date).format("ll")}`;
    };
    return (
      <DatePickerButton
        onClick={onClick}
        style={{ padding: "8px 24px", height: "38px" }}
      >
        <DateContainer style={{ fontSize: 17 }}>
          {date ? `${formatDate(date, time)}` : "Pick any date"}
        </DateContainer>
        <CalendarIcon />
      </DatePickerButton>
    );
  });

  const isDropdownRequired = (attribute) => {
    if (
      needsToBeBooleanValues.includes(attribute) ||
      needsToBeDropdownValues.includes(attribute) ||
      needsToBeFixedDropdownValues.includes(attribute) 
    )
      return true;
    return false;
  };

  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [removeIdx, setRemoveIdx] = useState({ mainRow: "", subGroup: "" });

  const dialogHandler = (idx, subIdx = null) => {
    setRemoveIdx({ mainRow: idx, subGroup: subIdx });
    setRemoveDialogOpen(!removeDialogOpen);
  };

  const [isLoadingDeleteCohort, setIsLoadingDeleteCohort] = useState(false);

  const cohortSaveHandler = () => {
    for (const mainRow of mainRows) {
      for (const subGroup of mainRow.subGroups) {
        if (
          !cohortName ||
          !subGroup.attribute ||
          !subGroup.operator ||
          subGroup.value === undefined ||
          subGroup.value === null ||
          subGroup.value === ''
        ) {
          alert("Please fill all fields in every row before saving.");
          return;
        }
      }
    }
  
    let arr = [];
  
    mainRows.map((itm) => {
      let newArr = [];
      itm.subGroups.map((item) => {
        let today = moment();
        let op =
          item.operator?.value === "Does not contain"
            ? "__icontains"
            : item.operator?.value === "Contains"
            ? "__icontains"
            : item.operator?.value === "Is a timestamp after"
            ? "__gt"
            : item.operator?.value === "Is a timestamp before"
            ? "__lt"
            : item.operator?.value === "Is greater than"
            ? "__gte"
            : item.operator?.value === "Is less than"
            ? "__lte"
            : item.operator?.value === "Is a timestamp greater than"
            ? "__gte"
            : item.operator?.value === "Is a timestamp less than"
            ? "__lte"
            : "";
  
        let valueToSend;
        
        if ((item.attribute?.value === "nlp_range_start" ||
            item.attribute?.value === "nlp_range_end" ||
            item.attribute?.value === "initial_exam_date") &&
            item.operator?.value === "Is a timestamp greater than") {
          valueToSend = today.add(item.value, "days").format("YYYY-MM-DD");
        } 
        else if ((item.attribute?.value === "nlp_range_start" ||
            item.attribute?.value === "nlp_range_end" ||
            item.attribute?.value === "initial_exam_date") &&
            item.operator?.value === "Is a timestamp less than") {
          valueToSend = today.subtract(item.value, "days").format("YYYY-MM-DD");
        }
        else if (item.attribute?.value === "special_guideline_score" &&
          (item.operator?.value === "Is greater than" || item.operator?.value === "Is less than")) {
        valueToSend = item.value?.value ?? item.value;
      }
        else if (((item.operator?.value === "Is equal to" ||
            item.operator?.value === "Is not equal to" ||
            item.operator?.value === "Contains" ||
            item.operator?.value === "Does not contain") &&
            !needsToBeDateInputValues.includes(item.attribute?.value)) ||
            ((item.operator?.value === "Is a timestamp greater than" ||
              item.operator?.value === "Is a timestamp less than") &&
              needsToBeDateInputValues.includes(item.attribute?.value))) {
          valueToSend = item.value?.value ?? item.value;
        }
        else if (item.value instanceof Date || moment(item.value, "YYYY-MM-DD", true).isValid()) {
          valueToSend = moment(item.value).format("YYYY-MM-DD");
        }
        else {
          valueToSend = item.value?.value ?? item.value;
        }
  
        return newArr.push({
          label: item?.attribute?.label,
          operator: op,
          valueLabel: item.value?.label ?? item.value,
          attribute: item.attribute?.value,
          exclude:
            item.operator?.value === "Is not equal to" ||
            item.operator?.value === "Does not contain"
              ? 1
              : 0,
          value: valueToSend,
        });
      });
  
      if (newArr.length > 1) {
        arr.push({
          condition: itm.subGroupCondition,
          filters: newArr,
        });
      } else {
        arr.push(newArr[0]);
      }
    });
  
    const dataToSend = {
      title: cohortName,
      trigger_cio_event: isChecked,
      computed_status_criteria: isChecked && computedReportData?.value ? computedReportData?.value : null,
      raw_filters: {
        condition: selectedOperator.value,
        filters: arr,
      },
    };
  
    if (isEditClicked) {
      let id = props.location.state.data.id;
      dispatch(updateReportCohort(id, dataToSend)).then(() => {
        history.push(`/auth/radAdmin/followUp/cohorts?tab=reports`, {
          data: "reports",
        });
      });
    } else {
      dispatch(createCohortReport(dataToSend)).then((res) => {
        if (res && res.success) {
          history.push(`/auth/radAdmin/followUp/cohorts?tab=reports`, {
            data: "reports",
          });
        }
      });
    }
  };

    const [loading, setLoading] = useState(false);
    
      const [referrerPage, setReferrerPage] = useState(1);
      const [query, setQuery] = useState("");
      const [referrerList, setReferrerList] = useState([]);
      const referrerOptionsList = referrerList?.length
      ? referrerList
          .map((item) => ({
            value: item.id,
            label: `${item?.first_name} ${item?.last_name}`,
            category: "referrers",
          }))
          .filter((item) => item.value)
      : [];
  

   const onInputChange = debounce(async (inputValue) => {
      if (inputValue) {
        setLoading(true);
        setReferrerList([]);
        setQuery(inputValue);
        setReferrerPage(1);
        const res = await dispatch(
          getReferrersForDropdownOptions(`?last_name__icontains=${inputValue}`)
        );
        if (res) {
          setReferrerList(res?.results);
          if (res?.next) {
            setReferrerPage(2);
          }
        }
        setLoading(false);
      } else {
        setReferrerList([]);
        setReferrerPage(1);
      }
    }, 1000);
  
    const loadMoreOptions = async () => {
      if (referrerPage > 1 && referrerOptionsList?.length >= 10) {
        setLoading(true);
        const res = await dispatch(
          getReferrersForDropdownOptions(
            `?last_name__icontains=${query}`,
            referrerPage
          )
        );
        setReferrerList((prev) => [...prev, ...res?.results]);
        if (res.next) {
          setReferrerPage((prev) => prev + 1);
        } else {
          setReferrerPage(1);
        }
        setLoading(false);
      }
    };
  
    const colourStyles = {
      placeholder: (styles) => ({ ...styles, fontSize: "14px" }),
      control: (styles) => ({ ...styles, backgroundColor: "white" }),
      option: (styles, { isDisabled, isSelected }) => {
        return {
          ...styles,
          fontSize: "14px",
          color: "black",
          cursor: isDisabled ? "not-allowed" : "default",
          backgroundColor: isSelected ? "#D9ECFF" : "white",
          display: "flex",
        };
      },
      multiValue: (styles, { data }) => ({
        ...styles,
        borderRadius: "25px",
        backgroundColor: "#EEEEEE",
        color: "#A1A1A1",
        padding: "4px 10px",
      }),
      multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: "#A1A1A1",
        fontSize: "10px",
      }),
    };

  return (
    <Box p={30}>
      {removeDialogOpen && (
        <RemoveConfirmation
          content="Are you sure you want to remove this Dimension?"
          openDialog={removeDialogOpen}
          dialogHandler={dialogHandler}
          isLoading={isLoadingDeleteCohort}
          deleteHandler={() => {
            if (removeIdx.subGroup !== null && removeIdx.subGroup !== "") {
              removeSubGroup(removeIdx.mainRow, removeIdx.subGroup);
            } else {
              removeMainRow(removeIdx.mainRow);
            }
            setRemoveIdx({ mainRow: "", subGroup: "" });
            setRemoveDialogOpen(false);
          }}
          removeHeader={"Yes, Remove Dimension"}
          heading={"Remove Dimension"}
        />
      )}
      <HeaderContainer>
        <PageTitle color="#00AEEF">
          {isEditClicked ? "Edit Cohort" : "Create Cohort"}
        </PageTitle>
      </HeaderContainer>

      <Card
        style={{ paddingBottom: "30px", paddingTop: "30px", textAlign: "left" }}
      >
        <Container>
          <Section>
            <SelectContainer>
              <SelectDropdownTitle>Cohort Title *</SelectDropdownTitle>
              <TextField
                id="outlined-uncontrolled"
                variant="outlined"
                value={cohortName}
                onChange={(e) => setCohortName(e.target.value)}
                className={classes.title}
                placeholder="Create list name"
                InputProps={{
                  style: {
                    height: "38px",
                  },
                }}
              />
            </SelectContainer>
         
           
            
          </Section>
          {
            hasReportSearchEventsEnabled &&   <RowContainer>
            <div>
              <CheckBoxLabel>
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                />

                <CheckboxTitle>Add to Messaging Campaign</CheckboxTitle>
              </CheckBoxLabel>
            </div>
          </RowContainer>
          }
   {
              isChecked && 
              <RowContainer>
  <SelectContainer>
              <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginRight: "15px",
                            }}
                          >
                            <SelectDropdownTitle>Conversion Tracking</SelectDropdownTitle>
                            
                            <StyledTooltipWrapper
                              placement="right"
                              title={
                                "To select conversion tracking, please enable the messaging campaign"
                              }
                            >
                              <InfoTooltipIcon
                                style={{ cursor: "pointer", alignSelf: "center", marginBottom: '9px' }}
                              />
                            </StyledTooltipWrapper>
                            </div>
                        <Select
                          components={{
                            IndicatorsContainer,
                            Option: RadioOption,
                          }}
                          classNamePrefix="select"
                          options={computedResults?.map((itm) => ({
                            ...itm,
                            label: capitalize(itm.name?.replace(/_/g, " ")),
                            value: itm.id,
                          }))}
                          value={computedReportData}
                          onChange={(itm) => {
                            setComputedReportData(itm)
                          }}
                          styles={{
                            option: (styles) => ({
                              ...styles,
                              fontSize: "14px",
                            }),
                          }}
                          isClearable
                       />
            </SelectContainer>
              </RowContainer>

              
                
              
            
            }
        
        {
                        isChecked &&  computedReportData &&
                        <div style={{marginTop:'20px'}}>
                        <div>
                         <SelectDropdownTitle>Computed Status <div style={{fontWeight:400, color:'black'}} >  {computedReportData?.computed_status_filter?.map(itm=>itm.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()))?.join(', ')?? '-'}
                         </div> 
                          </SelectDropdownTitle> 
                          </div> 
                          <div>
                         <SelectDropdownTitle>Days <div style={{fontWeight:400, color:'black'}} >  {computedReportData?.days ?? '-'}
                         </div> 
                          </SelectDropdownTitle> 
                          </div> 
                          <div>
                          <SelectDropdownTitle>
                          Modality Mappings    <ol style={{ fontWeight: 400, color: 'black', margin: 0, paddingLeft:13 }}>
    {computedReportData?.modality_mappings?.map((itm, index) => (
      <li key={index} style={{ marginBottom: '4px' }}>
        Initial Modality: {itm.report2_modality}, Subsequent Modality: {itm.subsequent_modality}
      </li>
    ))}
  </ol>
                            </SelectDropdownTitle> 

                            <SelectDropdownTitle>
                          Exam Code Mappings    <ol style={{ fontWeight: 400, color: 'black', margin: 0, paddingLeft:13 }}>
    {computedReportData?.exam_code_mappings?.map((itm, index) => (
      <li key={index} style={{ marginBottom: '4px' }}>
        Initial Exam Code: {itm.report2_exam_code}, Subsequent Exam Code: {itm.subsequent_exam_code}
      </li>
    ))}
  </ol>
                            </SelectDropdownTitle> 
                          
                          </div>
                        </div>

        }
        
          {mainRows.map((mainRow, mainRowIndex) => (
            <>
              {mainRowIndex > 0 && (
                <SwitchContainer>
                  <SwitchButton
                    active={selectedOperator.value === "and"}
                    onClick={() => {
                      setSelectedOperator({
                        value: "and",
                        label: "AND",
                        category: "Operator",
                      });
                    }}
                  >
                    and
                  </SwitchButton>
                  <SwitchButton
                    active={selectedOperator.value === "or"}
                    onClick={() => {
                      setSelectedOperator({
                        value: "or",
                        label: "OR",
                        category: "Operator",
                      });
                    }}
                  >
                    or
                  </SwitchButton>
                </SwitchContainer>
                // <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                //   <button onClick={() => toggleMainRowCondition()}>
                //     {mainRowCondition}
                //   </button>
                // </div>
              )}
              <div
                key={mainRowIndex}
                style={{
                  border: "1px solid gray",
                  marginTop: "20px",
                  marginBottom: "20px",
                  padding: "10px"
                }}
              >
                <div></div>

                {mainRow.subGroups.map((subGroup, subGroupIndex) => (
                  <>
                    {subGroupIndex > 0 && (
                      <SwitchContainer>
                        <SwitchButton
                          active={mainRow.subGroupCondition === "and"}
                          onClick={() => {
                            toggleSubGroupCondition(mainRowIndex);
                          }}
                        >
                          and
                        </SwitchButton>
                        <SwitchButton
                          active={mainRow.subGroupCondition === "or"}
                          onClick={() => {
                            toggleSubGroupCondition(mainRowIndex);
                          }}
                        >
                          or
                        </SwitchButton>
                      </SwitchContainer>
                    )}
                    <div
                      key={subGroupIndex}
                      style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        display: "flex",
                        gap: "20px",
                      }}
                    >
                      <SelectContainer>
                        <SelectDropdownTitle>Attribute *</SelectDropdownTitle>
                        <Select
                          components={{
                            IndicatorsContainer,
                            Option: RadioOption,
                          }}
                          classNamePrefix="select"
                          options={filterOption?.filter((itm) => {
                              if (itm.key === 'computed_status') {
                                return isChecked && computedReportData?.value;
                              }
                              return true;
                            }).map((itm) => ({
                              label: capitalize(itm.label?.replace(/_/g, " ")),
                              value: itm.key,
                            }))}
                          value={subGroup.attribute}
                          onChange={(itm) => {
                            updateSubGroupField(
                              mainRowIndex,
                              subGroupIndex,
                              "attribute",
                              itm
                            );
                            if (needsToBeDropdownValues.includes(itm?.value)) {
                              dispatch(
                                getDropdownValuesForCohortReport(
                                  itm.value
                                )
                              );
                            }
                            // setValue("Values");
                            // setOperator(null);
                          }}
                          styles={{
                            option: (styles) => ({
                              ...styles,
                              fontSize: "14px",
                            }),
                          }}
                          isClearable
                        />
                      </SelectContainer>

<SelectContainer>
  <SelectDropdownTitle>Operator *</SelectDropdownTitle>
  <Select
    components={{
      IndicatorsContainer,
      Option: RadioOption,
    }}
    classNamePrefix="select"
    options={
      subGroup.attribute?.value === "special_guideline_score" ||  subGroup.attribute?.value === "guideline_score"
          ? operatorsArrayDropdownSpecial.map((itm) => ({
            label: itm,
            value: itm,
          }))
          : subGroup.attribute?.value === "radiologist" || subGroup.attribute?.value === "referring_physician"
          ? messageOnlyOperator.map((itm) => ({
            label: itm,
            value: itm,
          }))
        : needsToBeDropdownValues.includes(subGroup.attribute?.value)
        ? operatorsArrayDropdownOnly.map((itm) => ({
            label: itm,
            value: itm,
          }))
        : needsToBeBooleanValues.includes(subGroup.attribute?.value)
        ? operatorsArrayBooleanOnly.map((itm) => ({
            label: itm,
            value: itm,
          }))
        : needsToBeDateInputValues.includes(subGroup.attribute?.value)
        ? operatorsArrayDate.map((itm) => ({
            label: itm,
            value: itm,
          }))
        : operatorsArrayText.map((itm) => ({
            label: itm,
            value: itm,
          }))
    }
    value={subGroup.operator}
    onChange={(itm) => {
      updateSubGroupField(
        mainRowIndex,
        subGroupIndex,
        "operator",
        itm
      );
    }}
    styles={{
      option: (styles) => ({
        ...styles,
        fontSize: "14px",
      }),
    }}
    isClearable
  />
</SelectContainer>
{subGroup.attribute && subGroup.operator && (
  <SelectContainer>
    <SelectDropdownTitle>value *</SelectDropdownTitle>
    
    {subGroup.attribute.value === "special_guideline_score" ? (
          <TextField
            id="special-guideline-score-value"
            variant="outlined"
            type="number"
            value={subGroup.value}
            onChange={(itm) => {
              updateSubGroupField(
                mainRowIndex,
                subGroupIndex,
                "value",
                itm.target.value
              );
            }}
            className={classes.textField}
            placeholder="Enter numeric value"
            InputProps={{
              style: {
                height: "38px",
              },
            }}
          />
        
    ) : subGroup.attribute.value === "guideline_score" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={guidelineScoreOptions}
        value={subGroup.value}
        closeMenuOnSelect={true}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "special_guideline_type" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={specialGuidelineTypeOptions}
        value={subGroup.value}
        closeMenuOnSelect={true}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "referring_physician" ? (
      <Select
        className="basic-multi-select"
        classNamePrefix="select"
        options={referrerOptionsList}
        value={subGroup.value}
        isMulti
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
        components={{
          Option,
          IndicatorsContainer,
        }}
        allowSelectAll={true}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={colourStyles}
        onInputChange={onInputChange}
        placeholder={
          loading ? "Searching" : "Search by lastname"
        }
        isLoading={loading}
        onMenuScrollToBottom={loadMoreOptions}
        onFocus={() => setReferrerList([])}
      />
    ) : subGroup.attribute.value === "radiologist" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={radiologistOptions}
        value={subGroup.value}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "computed_status" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={statusList}
        value={subGroup.value}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "location_address" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={locationOptions}
        value={subGroup.value}
        closeMenuOnSelect={false}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "guideline_type" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={guidelineTypeOptions}
        value={subGroup.value}
        closeMenuOnSelect={true}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : subGroup.attribute.value === "guideline_type_score" ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        className="basic-multi-select"
        classNamePrefix="select"
        options={guidelineTypeScoreOptions}
        value={subGroup.value}
        closeMenuOnSelect={true}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
          control: (styles) => ({
            ...styles,
            borderRadius: "4px",
          }),
        }}
        isClearable
      />
    ) : isDropdownRequired(subGroup.attribute?.value) &&
      subGroup.operator !== "Is a timestamp after" &&
      subGroup.operator !== "Is a timestamp before" &&
      !needsToBeDateInputValues.includes(subGroup.attribute?.value) ? (
      <Select
        components={{
          IndicatorsContainer,
          Option: RadioOption,
        }}
        classNamePrefix="select"
        options={
          needsToBeDropdownValues.includes(subGroup.attribute?.value)
            ? getFixedValues(subGroup.attribute?.value)?.map((itm) => ({
                label: itm,
                value: itm,
              }))
            : booleanValues.map((itm) => ({
                label: itm,
                value: itm,
              }))
        }
        value={subGroup.value}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        styles={{
          option: (styles) => ({
            ...styles,
            fontSize: "14px",
          }),
        }}
        isClearable
      />
    ) : ((subGroup.operator?.value === "Is equal to" ||
        subGroup.operator?.value === "Is not equal to" ||
        subGroup.operator?.value === "Operators" ||
        subGroup.operator?.value === "Contains" ||
        subGroup.operator?.value === "Does not contain" ||
        subGroup.operator?.value === "Is greater than" ||
        subGroup.operator?.value === "Is less than") &&
        !needsToBeDateInputValues?.includes(subGroup.attribute?.value)) ||
      ((subGroup.operator?.value === "Is a timestamp greater than" ||
        subGroup.operator?.value === "Is a timestamp less than") &&
        needsToBeDateInputValues?.includes(subGroup.attribute?.value)) ? (
      <TextField
        id="outlined-uncontrolled"
        variant="outlined"
        type={
          subGroup.operator?.value === "Is a timestamp greater than" ||
          subGroup.operator?.value === "Is a timestamp less than" ||
          subGroup.operator?.value === "Is greater than" ||
          subGroup.operator?.value === "Is less than"
            ? "number"
            : "text"
        }
        value={subGroup.value}
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm.target.value
          );
        }}
        className={classes.textField}
        placeholder={
          subGroup.operator?.value === "Is a timestamp greater than" ||
          subGroup.operator?.value === "Is a timestamp less than"
            ? "Enter # of days from today"
            : subGroup.operator?.value === "Is greater than" ||
              subGroup.operator?.value === "Is less than"
            ? "Enter numeric value"
            : "Enter value"
        }
        InputProps={{
          style: {
            height: "38px",
          },
        }}
      />
    ) : (
      <DatePicker
        onChange={(itm) => {
          updateSubGroupField(
            mainRowIndex,
            subGroupIndex,
            "value",
            itm
          );
        }}
        dateFormat="MM/dd/yyyy"
        selected={subGroup.value ? new Date(subGroup.value) : null}
        customInput={<DatePickerInput date={subGroup.value} />}
        className={classes.datePicker}
        popperPlacement="bottom"
        popperModifiers={{
          flip: { behavior: ["bottom"] },
          preventOverflow: { enabled: false },
          hide: { enabled: false },
        }}
      />
    )}
  </SelectContainer>
)}

{mainRow.subGroups.length > 1 && (
  <SelectContainer style={{ width: "fit-content" }}>
    <SelectDropdownTitle style={{ visibility: "hidden" }}>
      delete
    </SelectDropdownTitle>
    <Remove
      onClick={(e) => {
        e.stopPropagation();
        dialogHandler(mainRowIndex, subGroupIndex);
      }}
    >
      <IconContainer>
        <RemoveRecoIcon />
        <RemoveRecoIconHover className="light" />
      </IconContainer>
    </Remove>
  </SelectContainer>
                        // <button
                        //   onClick={() =>
                        //     removeSubGroup(mainRowIndex, subGroupIndex)
                        //   }
                        // >
                        //   Remove Sub-group
                        // </button>
                      )}
                    </div>
                  </>
                ))}

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 40,
                    gap: "20px",
                  }}
                >
                  <Button
                                      classes={{
                                        label: classes.label,
                                        root: classes.additionalSubDimensionsButton,
                                      }}
                                      onClick={() => addSubGroup(mainRowIndex)}
                                    >
                                      Add Additional Sub Dimensions
                                    </Button>
                  {mainRows.length > 1 && (
                    <Button
                      classes={{
                        label: classes.label,
                        root: classes.removeAllSubDimensionsButton,
                      }}
                      onClick={() => {
                        dialogHandler(mainRowIndex);
                      }}
                      // onClick={() => removeMainRow(mainRowIndex)}
                    >
                      Remove All Sub Dimensions
                    </Button>
                  )}
                </div>
              </div>
            </>
          ))}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 40,
              justifyContent: "flex-end",
              gap: "20px",
            }}
          >
            <Button
              classes={{
                label: classes.label,
                root: classes.additionalDimensionsButton,
              }}
              onClick={addMainRow}
            >
              Add Additional Dimensions
            </Button>
            <Button
              classes={{ label: classes.label, root: classes.saveButton }}
              onClick={() => cohortSaveHandler()}
            >
              {isLoading ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Save Cohort"
              )}
            </Button>
          </div>
        </Container>
      </Card>
    </Box>
  );
};

export default CreateReportCohort;
